import { useState } from 'react';

import { Icon, IconKebab } from '@flixbus/honeycomb-icons-react';
import { Button, Dropdown, DropdownItem } from '@flixbus/honeycomb-react';

import { MODAL_NAMES } from 'common/activeElements/modals/modalNames';
import { SIDEBAR_NAMES } from 'common/activeElements/sidebars/sidebarsNames';
import { useActiveElements } from 'global/ActiveElements/useActiveElements';

import { EMPLOYMENT_ACTION_LABELS, EMPLOYMENT_CONTROLS_TEXT } from './text';

import styles from './styles.module.css';

const EmploymentControls = () => {
	const [open, setOpen] = useState(false);
	const active = useActiveElements();

	const toggle = (isActive) => setOpen(isActive);

	const handleSelect = (e, actionName) => {
		e.preventDefault();
		// open the correct element
		active.setActiveElement(actionName, {});
		toggle(false);
	};

	const linkArray = [
		<DropdownItem
			key="add-employment-change"
			Elem="a"
			href=""
			onClick={(e) => handleSelect(e, MODAL_NAMES.employmentType)}
		>
			{EMPLOYMENT_ACTION_LABELS[MODAL_NAMES.employmentType]}
		</DropdownItem>,
		<DropdownItem
			key="view-employment-history"
			Elem="a"
			href="/"
			onClick={(e) => handleSelect(e, SIDEBAR_NAMES.employmentLog)}
		>
			{EMPLOYMENT_ACTION_LABELS[SIDEBAR_NAMES.employmentLog]}
		</DropdownItem>,
	];

	return (
		<div className={styles.controls}>
			<Dropdown
				active={open}
				links={linkArray}
				onToggle={toggle}
				yPosition="bottom"
				xPosition="left"
			>
				<Button display="square" aria-label={EMPLOYMENT_CONTROLS_TEXT.buttonAriaLabel}>
					<Icon InlineIcon={IconKebab} />
				</Button>
			</Dropdown>
		</div>
	);
};

export default EmploymentControls;
